import { makeBenefitsApi } from 'src/http/api/internal/internal-http';
import { ScnEventsRepository } from 'src/repositories/benefits/scn-events.repository';
import { ScnEventType } from 'src/types/scn-events';
import { create } from 'zustand';

type States = {
  loadingScnEventsList: boolean;
  loadingScnEventCreate: boolean;
  loadingScnEventDetails: boolean;
  loadingScnEventUpdate: boolean;
  scnEventsList: ScnEventType[];
  scnEventDetails: ScnEventType | null;
};

type Actions = {
  getScnEventsList: () => Promise<void>;
  getScnEventDetails: (id: string) => Promise<void>;
  createScnEvent: (scnEvent: any) => Promise<void>;
  updateScnEvent: (id: string, scnEvent: any) => Promise<void>;
  resetScnEventDetails: () => void;
};

type Store = Actions & States;

const initialValues = {
  loadingScnEventsList: false,
  loadingScnEventCreate: false,
  loadingScnEventDetails: false,
  loadingScnEventUpdate: false,
  scnEventsList: [],
  scnEventDetails: null,
};

const repository = new ScnEventsRepository(makeBenefitsApi());

export const useScnEventsStore = create<Store>((set) => ({
  ...initialValues,

  getScnEventsList: async () => {
    set({ loadingScnEventsList: true });
    const response = await repository.getScnEventsList();
    if (response.isLeft()) {
      set({ scnEventsList: [], loadingScnEventsList: false });
      throw new Error(response.value.message);
    }
    set({
      scnEventsList: response.value,
      loadingScnEventsList: false,
    });
  },

  getScnEventDetails: async (id: string) => {
    set({ loadingScnEventDetails: true });
    const response = await repository.getScnEventDetails(id);
    if (response.isLeft()) {
      set({ scnEventDetails: null, loadingScnEventDetails: false });
      throw new Error(response.value.message);
    }
    set({
      scnEventDetails: response.value,
      loadingScnEventDetails: false,
    });
  },

  createScnEvent: async (scnEvent: any) => {
    set({ loadingScnEventCreate: true });
    const response = await repository.createScnEvent(scnEvent);
    if (response.isLeft()) {
      set({ loadingScnEventCreate: false });
      throw new Error(response.value.message);
    }
    set({ loadingScnEventCreate: false });
  },

  updateScnEvent: async (id: string, scnEvent: any) => {
    set({ loadingScnEventUpdate: true });
    const response = await repository.updateScnEvent(id, scnEvent);
    if (response.isLeft()) {
      set({ loadingScnEventUpdate: false });
      throw new Error(response.value.message);
    }
    set({ loadingScnEventUpdate: false });
  },

  resetScnEventDetails: () => set({ scnEventDetails: null }),
}));
